import React, { useEffect } from 'react';

import StatusPendingBttAgGridTable from 'Views/PendingBtt/AgGridTable/StatusPendingBttAgGridTable';

const StatusPendingBtt = () => {
  useEffect(() => {
    document.title = 'F2W - PendingBtt';
  }, []);

  return (
    <React.Fragment>
      <h4>Pending BTT</h4>
      <StatusPendingBttAgGridTable />
    </React.Fragment>
  );
};

export default StatusPendingBtt;
